( () => {
	const comparisonAnchor = '#comparador';
	const comparisonTriggerSelector = `[href="${ comparisonAnchor }"], [id="comparador"]`;
	const comparisonSectionSelector = '.shopify-section.comparison-table-section';
	const logPrefix = '[ormu_theme][comparador]';

	const getNearestComparisonSection = ( trigger ) => {
		const comparisonSections = Array.from( document.querySelectorAll( comparisonSectionSelector ) );

		if( !comparisonSections.length ){
			return null;
		}

		const triggerTop = trigger.getBoundingClientRect().top + window.scrollY;

		return comparisonSections.reduce( ( nearestSection, currentSection ) => {
			const currentTop = currentSection.getBoundingClientRect().top + window.scrollY;

			if( !nearestSection ){
				return currentSection;
			}

			const nearestTop = nearestSection.getBoundingClientRect().top + window.scrollY;

			return Math.abs( currentTop - triggerTop ) < Math.abs( nearestTop - triggerTop ) ? currentSection : nearestSection;
		}, null );
	};

	const getScrollOffset = () => {
		return 0;
	};

	console.log( `${ logPrefix } Initialized`, {
		comparisonTriggerSelector,
		comparisonSectionSelector
	} );

	document.addEventListener( 'click', ( event ) => {
		const trigger = event.target instanceof Element ? event.target.closest( comparisonTriggerSelector ) : null;

		if( !trigger ){
			return;
		}

		console.log( `${ logPrefix } Trigger clicked`, {
			trigger,
			href: trigger.getAttribute( 'href' ),
			id: trigger.id
		} );

		if( event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ){
			console.log( `${ logPrefix } Click ignored`, {
				defaultPrevented: event.defaultPrevented,
				button: event.button,
				metaKey: event.metaKey,
				ctrlKey: event.ctrlKey,
				shiftKey: event.shiftKey,
				altKey: event.altKey
			} );
			return;
		}

		const targetSection = getNearestComparisonSection( trigger );

		if( !targetSection ){
			console.log( `${ logPrefix } No comparison section found`, {
				selector: comparisonSectionSelector
			} );
			return;
		}

		event.preventDefault();

		const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
		const scrollOffset = getScrollOffset();
		const top = targetSection.getBoundingClientRect().top + window.scrollY - scrollOffset;

		console.log( `${ logPrefix } Scrolling to comparison section`, {
			targetSection,
			prefersReducedMotion,
			scrollOffset,
			scrollTop: Math.max( 0, top )
		} );

		window.scrollTo( {
			top: Math.max( 0, top ),
			behavior: prefersReducedMotion ? 'auto' : 'smooth'
		} );
	} );
} )();

if( !customElements.get( 'ormu-open-product-accordion' ) ){
	class OrmuOpenProductAccordion extends HTMLElement {
		connectedCallback(){
			const productInfo = this.closest( 'product-info' );

			if( productInfo?.querySelector( 'ormu-open-product-accordion' ) !== this ){
				return;
			}

			const accordion = this.closest( '.product__accordion[is="accordion-details"]' );

			if( accordion ){
				accordion.open = true;
			}
		}
	}

	customElements.define( 'ormu-open-product-accordion', OrmuOpenProductAccordion );
}
